import { Root } from '@radix-ui/react-popover';

export type PopoverRootProps = React.ComponentPropsWithoutRef<typeof Root>;

const PopoverRoot = Root;

export default PopoverRoot;
